module.exports = __webpack_public_path__ + "img/twitter.8c19b44e.png";